import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { Component } from '@angular/core';

import { ScriptLoaderService, ClassService } from '../../../../../_services';
import { InvestorFormComponent } from '../investor-form';
import { Investor } from '../../../../../_models';

@Component({
    selector: 'app-investor-form',
    templateUrl: '../investor-form/investor-form.component.html',
    styleUrls: ['../investor-form/investor-form.component.scss']
})
export class InvestorNewComponent extends InvestorFormComponent {
    formHeader = {
        icon: 'fa fa-user',
        text: 'REGISTRAR PROPIETARIO'
    }
    investor: any = null;
    constructor(private _scriptNew: ScriptLoaderService, private _locationNew: Location, fbNew: FormBuilder,
        private _classServiceNew: ClassService,
        private routerNew: Router,
        private investorDataNew: Investor
    ) {
        super(_scriptNew, _locationNew, fbNew, _classServiceNew, routerNew, investorDataNew);
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid) this.requests$ =
                this.investorData.post(formValue);
        });
        this.dataFetched = true;
    }
    data(investor) {
        this.investor = investor;
    }
    end() {
        if (this.investor)
            this.router.navigate([`/investors/${this.investor.id}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-new/investor-new.component.ts